import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { initSentry } from "common/errorTracker";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { StoreProvider } from "./Store";
//for pma Cover letter
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
/**common css files */
import "./index.css";
import "views/Pma/PmaEditor/CommonEditor/ivyprestoFonts.scss";
// Note: suppressWarnings disabled after MUI v5 migration
// Webpack 5 polyfills
import { webpack5Polyfills } from "common/utils/webpack5.util";
// Auth helpers (used for early root redirect)
import { IsValidLoginAuth, IsValidSemiAuth } from "./common/storage";

/**Client */
import { Provider } from "react-redux";
import { store } from "./_store";
import disableConsoleLogs from "common/utils/DisableConsoleLogs";

/**Initialize Sentry (must run before anything else) */
initSentry();

/**Disable console logs */
disableConsoleLogs();

/**Initialize webpack 5 polyfills */
webpack5Polyfills();

// Let React Router/RootRedirect handle root redirect logic

const container = document.getElementById("root");
const root = createRoot(container);

const errorFallback = (
  <div style={{ padding: "48px 24px", textAlign: "center", fontFamily: "sans-serif" }}>
    <h2>Something went wrong.</h2>
    <p>Please refresh the page. If the problem persists, contact ListGen support.</p>
  </div>
);

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={errorFallback} showDialog={false}>
      <StoreProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </StoreProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// version: '3.1'

// services:
//   n8n:
//     image: n8nio/n8n
//     restart: always
//     ports:
//       - "5678:5678"
//     environment:
//       - GENERIC_TIMEZONE=Asia/Kolkata
//       - N8N_BASIC_AUTH_ACTIVE=true
//       - N8N_BASIC_AUTH_USER=admin
//       - N8N_BASIC_AUTH_PASSWORD=XYu@#uipfhgj
//       - WEBHOOK_TUNNEL_URL=http://13.221.80.11:5678
//       - N8N_HOST=13.221.80.11
//       - N8N_PORT=5678
//     volumes:
//       - ./n8n_data:/home/node/.n8n

// sudo tee /etc/nginx/sites-available/nodai > /dev/null <<'EOF'
// server {
//     listen 80;
//     server_name nodai.listgen.com;

//     # Redirect HTTP to HTTPS
//     return 301 https://\$host\$request_uri;
// }

// server {
//     listen 443 ssl http2;
//     server_name nodai.listgen.com;

//     ssl_certificate /etc/letsencrypt/live/nodai.listgen.com/fullchain.pem;
//     ssl_certificate_key /etc/letsencrypt/live/nodai.listgen.com/privkey.pem;
//     include /etc/letsencrypt/options-ssl-nginx.conf;
//     ssl_dhparam /etc/letsencrypt/ssl-dhparams.pem;

//     # Max body size (important for big workflows)
//     client_max_body_size 100M;

//     location / {
//         proxy_pass http://localhost:5678;
//         proxy_http_version 1.1;

//         # Required for WebSocket support
//         proxy_set_header Upgrade \$http_upgrade;
//         proxy_set_header Connection "upgrade";

//         # Forwarding headers
//         proxy_set_header Host \$host;
//         proxy_set_header X-Real-IP \$remote_addr;
//         proxy_set_header X-Forwarded-For \$proxy_add_x_forwarded_for;
//         proxy_set_header X-Forwarded-Proto \$scheme;
//     }
// }
// EOF
